import { useState } from 'react';

const classMapping = {
  "airplane_single_engine_land": "Airplane Single-Engine Land",
  "airplane_multi_engine_land": "Airplane Multi-Engine Land",
  "airplane_single_engine_sea": "Airplane Single-Engine Sea",
  "airplane_multi_engine_sea": "Airplane Multi-Engine Sea",
  "rotorcraft": "Rotorcraft (Helicopters)",
  "lighter_than_air": "Lighter-Than-Air (Balloons, Airships)",
  "powered_parachute": "Powered Parachute",
  "glider": "Glider",
  "weight_shift_control_aircraft": "Weight-Shift Control Aircraft",
};


const AircraftForm = ({ initialData, onSubmit, onCancel, yearOptions }) => {
  const [formData, setFormData] = useState(initialData || {
    year: '',
    make: '',
    model: '',
    registration: '',
    category: '',
    class: '',
  });

  const sortedYearOptions = [...yearOptions].sort((a, b) => b - a);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 border rounded-lg">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium">Year</label>
          <select
            value={formData.year || ""}
            onChange={(e) => setFormData({ ...formData, year: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg"
          >
            <option value="" disabled>Select Year</option>
            {sortedYearOptions.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-sm font-medium">Registration</label>
          <input
            type="text"
            value={formData.registration || ""}
            onChange={(e) => setFormData({ ...formData, registration: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg"
          />
        </div>
        <div>
          <label className="text-sm font-medium">Make</label>
          <input
            type="text"
            value={formData.make}
            onChange={(e) => setFormData({ ...formData, make: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium">Model</label>
          <input
            type="text"
            value={formData.model}
            onChange={(e) => setFormData({ ...formData, model: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium">Category</label>
          <select
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg"
            required
          >
            <option value="">Select Category</option>
            <option value="Airplane">Airplane</option>
            <option value="Rotorcraft">Rotorcraft</option>
            <option value="Glider">Glider</option>
            <option value="Lighter-than-air">Lighter-than-air</option>
          </select>
        </div>
        <div>
          <label className="text-sm font-medium">Class</label>
          <select
            value={formData.class}
            onChange={(e) => setFormData({ ...formData, class: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg"
            required
          >
            <option value="">Select Class</option>
            {Object.entries(classMapping).map(([value, label]) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-center">
          <input
            id="complex"
            type="checkbox"
            checked={formData.complex || false}
            onChange={(e) => setFormData({ ...formData, complex: e.target.checked })}
            className="mr-2"
          />
          <label htmlFor="complex" className="text-sm font-medium cursor-pointer">
            Complex
          </label>
        </div>
        <div className="flex items-center">
          <input
            id="highPerformance"
            type="checkbox"
            checked={formData.highPerformance || false}
            onChange={(e) => setFormData({ ...formData, highPerformance: e.target.checked })}
            className="mr-2"
          />
          <label htmlFor="highPerformance" className="text-sm font-medium cursor-pointer">
            High Performance
          </label>
        </div>
        <div className="flex items-center">
          <input
            id="pressurized"
            type="checkbox"
            checked={formData.pressurized || false}
            onChange={(e) => setFormData({ ...formData, pressurized: e.target.checked })}
            className="mr-2"
          />
          <label htmlFor="pressurized" className="text-sm font-medium cursor-pointer">
            Pressurized
          </label>
        </div>
      </div>
      <div className="flex justify-end space-x-2">
        <button
          type="button"
          onClick={onCancel}
          className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default AircraftForm;
